export const activityTypeData = {
  course: 'Kurz',
  workshop: 'Workshop',
  training: 'Školení',
  seminar: 'Seminář',
  webinar: 'Webinář',
  conference: 'Konference',
  publication: 'Publikační / lektorská činnost',
  project: 'Projektová činnost',
  internship: 'Stáže / praxe',
  self_study: 'Samostudium',
  volunteering: 'Dobrovolnická činnost',
  // Keep last - ends the category list
  other: 'Jiné',
};

export const targetStateData = {
  waiting: 'Čekající',
  in_process: 'V procesu',
  finished: 'Dokončeno',
  incomplete: 'Nesplněno',
};

export const superCategoryNames = ['Já a dítě', 'Já a rodiče', 'Já a prostředí dětské skupiny', 'Já a instituce'];

export const superCategoryIconUrls = {
  'Já a dítě': 'assets/img/iconsDefault/superCategories/1_pap-child_color.svg',
  'Já a rodiče': 'assets/img/iconsDefault/superCategories/2_pap-parents_color.svg',
  'Já a prostředí dětské skupiny': 'assets/img/iconsDefault/superCategories/3_pap-groups_color.svg',
  'Já a instituce': 'assets/img/iconsDefault/superCategories/4_pap-institution_color.svg'
};

export const subCategoryNames = [
  'Rozvoj schopností dítěte',
  'Plánování a diagnostika',

  'Komunikace s rodiči',
  'Podpora vhodných postupů',

  'Spolupráce s dětmi',
  'Komunikace a bezpečí ve skupině',

  'Institucionální spolupráce',
  'Budování profese a profesních sítí'
];